import React, { useEffect, useState } from 'react';

import Request from '~/providers/Request';
import { historyPropType } from '~/config/routerPropTypes';
import CorporationRecord from '~/records/CorporationRecord';
import handleDataAttributes from '../utils/handleDataAttributes';

import Tabs from './Tabs';

function ShowPerson({ history }) {
  const { id } = history.location.route.getParams();
  const [record, setRecord] = useState(new CorporationRecord());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Promise.all([
      Request.get(`/admin/corporation/${id}`, {}).then((response) => response.data),
      Request.get(`/admin/corporations/corporation-branches/${id}`, {}).then((response) => response.data),
    ])
      .then(([corporation, branches]) => {
        // O ideal aqui, seria que a API retornasse os dados juntos, mas como não retorna,
        // foi necessário fazer isso manualmente
        // O backend foi feito há 6 meses atrás da implementação do frontend, e não foi feito com isso em mente
        // O Dev que fez o backend nem mesmo está na empresa agora que o front foi implementado
        const currentData = {
          ...corporation,
          branches,
        };

        setLoading(false);
        setRecord(record.updateAttributes(handleDataAttributes(currentData)));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  return (
    <Tabs id={id} loading={loading} record={record} setRecord={setRecord} />
  );
}

ShowPerson.propTypes = {
  history: historyPropType,
};

export default ShowPerson;
